import type { PotentialProfileSuggestionMutation } from 'apollo-gql'
import getMarketTrackingProperties from 'lib/tracking/avo/utils/getMarketTrackingProperties'

type TrackPotentialProfileSuggested = {
  result: PotentialProfileSuggestionMutation['market']['suggestPotentialProfile']
}

const trackPotentialProfileSuggested = async (
  parameters: TrackPotentialProfileSuggested,
): Promise<void> => {
  const { result } = parameters

  const { potentialProfileSuggested } = await import('./sdk')
  potentialProfileSuggested({
    ...getMarketTrackingProperties(),
    description: result.potentialProfileSuggestion.description,
    name: result.potentialProfileSuggestion.name,
    potentialProfileId: result.potentialProfileSuggestion.id,
  })
}

export default trackPotentialProfileSuggested
